import { createAsyncThunk } from "@reduxjs/toolkit";
import axios, { AxiosError } from "axios";
import { TAudioTrack, TAudioTrackResponse } from "../../types/audioTrack";
import $api, { API } from "../index";

export const getAudio = createAsyncThunk(
  "getAudioTracks",
  async (_, { rejectWithValue }): Promise<TAudioTrackResponse[]> => {
    try {
      const response = await $api.get(`${API.audioTracksPath}`);

      return response.data;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const addRemoveLike = createAsyncThunk(
  "trackAddRemoveLike",
  async (data: { id: string }, { rejectWithValue }): Promise<string> => {
    try {
      await $api.post(`${API.audioTracksPath}${API.likePath}${data.id}` );

      return data.id;
    } catch (e: any | AxiosError) {
      if (axios.isAxiosError(e)) {
        const axiosError = e as AxiosError;
        throw rejectWithValue(axiosError);
      }
      throw rejectWithValue(e.message);
    }
  }
);

export const updatePlayCount = createAsyncThunk(
    "updatePlayCounter",
    async (data:{id:string}, { rejectWithValue })=>{
        try {
            await $api.patch(`${API.audioTracksPath}${API.audioTrackPathUpdateCount}${data.id}`)
        }catch (e: any | AxiosError) {
            if (axios.isAxiosError(e)) {
                const axiosError = e as AxiosError;
                throw rejectWithValue(axiosError);
            }
            throw rejectWithValue(e.message);
        }
    })
